import { render } from "./AlertText.vue?vue&type=template&id=6101e7ef"
import script from "./AlertText.vue?vue&type=script&lang=js"
export * from "./AlertText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__